
import { useState, useRef, useEffect } from '@wordpress/element';

import { dashboardFilters } from '../includes/options';

import { useDashboard } from '../context/DashboardContext';

export default function Header() {
    const { fetchDashboardData, setFilters } = useDashboard();

    const [ dashboardFilter, setDashboardFilter ] = useState('last_30_days');
    
    const handleDashboardFilter = key => {
        if ( 'custom' != key ) {
            setDashboardFilter(key);
            const filterString = `period=${key}&`;
            setFilters(filterString);
            fetchDashboardData(filterString);
        }
    };

    const rangePickerRef = useRef(null);

    jQuery('#dropdownInformationButton').on('click', function(e) {
        console.log('1');
        e.stopPropagation();
        jQuery('#dropdownInformation').toggleClass('hidden');
    });

    useEffect(() => {


        // Initialize date range picker
        jQuery('input#daterange').daterangepicker();
        
        // Set up event handler for date range selection
        const handleDateRangeApply = function(ev, picker) {
            setDashboardFilter('custom');
            const startDate = picker.startDate.format('YYYY-MM-DD');
            const endDate = picker.endDate.format('YYYY-MM-DD');
            const filterString = `period=custom&start_date=${startDate}&end_date=${endDate}`;
            setFilters(filterString);
            fetchDashboardData(filterString);
            jQuery('#dropdownInformation').addClass('hidden');
        };
        
        jQuery('input#daterange').on('apply.daterangepicker', handleDateRangeApply);
        jQuery('input#daterange').on('cancel.daterangepicker', () => {
            jQuery('#dropdownInformation').addClass('hidden');
        });
        
        // Cleanup: remove event handler on unmount
        return () => {
            jQuery('input#daterange').off('apply.daterangepicker', handleDateRangeApply);
        };
    }, [setFilters, fetchDashboardData]);

    return (
        <div className="wholesale-dashboard-header bg-white flex items-center justify-between">
            <div className="dashboard-heading"><h1>Wholesale For WooCommerce</h1></div>
            <div className="inline-flex rounded-md shadow-xs filter-buttons" role="group">
                { dashboardFilters.length && dashboardFilters.map((element, index) => (
                    <>
                    <button
                        {...('custom' === element.key
                        ? {
                            id: 'dropdownInformationButton'
                        } : {})}
                        type="button"
                        className={`px-4 py-2 text-sm font-medium text-gray-900 bg-white border-gray-200 border hover:bg-gray-100 ${ ( 0 === index || dashboardFilters.length-1 === index ) ? `border rounded-${dashboardFilters.length-1 === index ? 'r' : 'l'}-lg` : 'border-t border-b cs-border-r-wd' } ${ ( element.key === dashboardFilter ) ? 'active' : null }`}
                        data-key={element.key}
                        onClick={e => handleDashboardFilter(e.currentTarget.dataset.key)}
                    >
                        { element.label }
                        { 'custom' == element.key ? (
                            <svg class="w-2.5 h-2.5 ms-3 inline align-middle" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                            </svg>
                        ) : '' }
                    </button>
                    { 'custom' == element.key ? (
                        <div id="dropdownInformation" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', transform: 'translate(323px, 47px)' }} class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm">
                            <div class="px-4 py-3 text-sm text-gray-900">
                                <svg style={{ position: 'absolute', top: '26px', left: '30px'}} class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                </svg>
                                <input type="text" id="daterange" name="daterange" placeholder="Select dates" style={{ width: '260px', paddingLeft: '40px' }} />
                            </div>
                        </div>
                    ) : ''}
                    </>
                )) }
            </div>
        </div>
    );
}